import { CompanyFavouriteDto } from '../../company/interfaces/CompanyFavouriteDto';

export const removeFavouriteCompany = (companies: CompanyFavouriteDto[], companyKey: number) =>
  companies.filter(company => company.companyKey !== companyKey);
export const addFavouriteCompany = (companies: CompanyFavouriteDto[], company: CompanyFavouriteDto) => [
  ...companies,
  company,
];
